// Decoders
import { pk } from 'fc-decoders'
import shapeData from './decoders/shapeData'

// Model Properties
import {
  PROP_SHAPE_ID,
  PROP_ASSET,
  PROP_SHAPE_DATA,
} from 'fc-model-shapes'

// Exports
export default {
  [PROP_SHAPE_ID]: pk,
  [PROP_ASSET]: pk,
  [PROP_SHAPE_DATA]: shapeData,
}
